/** biome-ignore-all lint/suspicious/noArrayIndexKey: <explanation> */
import { type FC, Fragment } from "react";
import type { Address } from "viem";

import type { CreditAccountOperation, TokensList } from "../model";
import type { ProtocolsList } from "../protocols";
import { HistoryLine } from "./line";

export interface HistoryBodyProps {
  underlyingToken: Address;
  tokens: TokensList;
  protocols: ProtocolsList;
  dataList: CreditAccountOperation[];
  chainId: number;
}

export const HistoryBody: FC<HistoryBodyProps> = ({
  dataList,
  underlyingToken,
  tokens,
  protocols,
  chainId,
}) => {
  return (
    <>
      {dataList.map((event, index, arr) => {
        const [eventDetails, underlyingEvents] = event.getDetails(
          underlyingToken,
          tokens,
        );
        const isLastEvent = index === arr.length - 1;
        const hasUnderlyingEvents =
          !!underlyingEvents && underlyingEvents.length > 0;

        return (
          <Fragment key={`${event.txHash}_${index}`}>
            <HistoryLine
              data={event}
              details={eventDetails}
              hideBorder={isLastEvent || hasUnderlyingEvents}
              tokens={tokens}
              protocols={protocols}
              index={{ index: 0, outOf: underlyingEvents?.length ?? 0 }}
              underlyingToken={underlyingToken}
              chainId={chainId}
            />
            {underlyingEvents
              ?.filter(e => e.operationType !== "OpenCreditAccount")
              .map((inner, innerIdx, innerArr) => {
                const [innerDetails] = inner.getDetails(
                  underlyingToken,
                  tokens,
                );
                const isLastInner = innerIdx === innerArr.length - 1;
                return (
                  <HistoryLine
                    key={`${inner.txHash}_${index}_${innerIdx}`}
                    data={inner}
                    details={innerDetails}
                    index={{
                      index: innerIdx + 1,
                      outOf: innerArr.length,
                    }}
                    hideBorder={(isLastEvent && isLastInner) || !isLastInner}
                    tokens={tokens}
                    protocols={protocols}
                    underlyingToken={underlyingToken}
                    chainId={chainId}
                  />
                );
              })}
          </Fragment>
        );
      })}
    </>
  );
};
